import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchyManagementSourceCard = _resolveComponent("HierarchyManagementSourceCard")
  const _component_HierarchyManagementTargetCard = _resolveComponent("HierarchyManagementTargetCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_HierarchyManagementSourceCard, {
      dimensions: _ctx.dimensions,
      optionsDate: _ctx.optionsDate,
      onLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('loading', $event))),
      onValidityDateSelected: _ctx.setValidityDate,
      onDimensionSelected: _ctx.setSelectedDimension,
      onNodeMetadataChanged: _ctx.onNodeMetadataChange,
      onHierarchyTypeSelected: _ctx.onHierarchyTypeSelected,
      onHierarchySelected: _ctx.onHierarchySelected
    }, null, 8, ["dimensions", "optionsDate", "onValidityDateSelected", "onDimensionSelected", "onNodeMetadataChanged", "onHierarchyTypeSelected", "onHierarchySelected"]),
    _createVNode(_component_HierarchyManagementTargetCard, {
      selectedDimension: _ctx.selectedDimension,
      validityDate: _ctx.validityDate,
      nodeMetadata: _ctx.nodeMetadata,
      selectedSourceHierarchy: _ctx.selectedHierarchy,
      onLoading: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('loading', $event))),
      onOptionsDateSelected: _ctx.setOptionsDate
    }, null, 8, ["selectedDimension", "validityDate", "nodeMetadata", "selectedSourceHierarchy", "onOptionsDateSelected"])
  ]))
}